import styled from "styled-components";
import Colors from "./colors";

export const Section = styled.section `
    padding-top: 120px;
    padding-bottom: 140px;

    @media screen and (max-width: 767px) {
        padding-top: 60px;
        padding-bottom: 80px;
    }
`

export const SectionPage = styled.section `
    margin-top: -59px;
    background-color: ${Colors.background};
    padding-top: 59px;
    min-height: 400px;
`

export const Error = styled.div `
    width: 100%;
    text-align: center;
    color: ${Colors.text.secondary};
    font-weight: 600;
    font-size: 14px;
` 


// WEBPACK FOOTER //
// ./src/shared/shared.js